import Box from "@mui/material/Box";
import React from "react";

const logos = [
    { image: 'cornerstone.png', width:  400, link: 'https://cornerstonechristianacademy.us/', team: 'cornerstone' },
    { image: 'rapids.svg', width: 600, link: 'https://rapids.club/soccer', team: 'rapids' },
    { image: 'sk.png', width: 600, link: 'https://www.sksoccerclub.org/', team: 'sk' },
    { image: 'usa.png', width: 300, link: 'https://unionspringsacademy.org/', team: 'usa' },
    { image: 'rsd.png', width: 300, link: 'https://www.rsdeaf.org/', team: 'rsd' },
    { image: 'intensity.png', width: 400, team: 'intensity'  },
    { image: 'scUnited.png', width: 400, team: 'scUnited'  },
    { image: 'grasshoppers.png', width: 400, team: 'scUnited'  }
];

const shuffleLogos = () => {
    let currentIndex = logos.length;
    let randomIndex:number;
    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [logos[currentIndex], logos[randomIndex]] = [
            logos[randomIndex], logos[currentIndex]];
    }
}

shuffleLogos();

export default function Home()  {

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'center', maxWidth: 'xl',
            alignItems: 'center', alignContent: 'center', gap: { xs: '30px', md: '60px' }, paddingTop: '40px', paddingLeft: '10px', paddingRight: '10px'}}>
            {logos.map((logo) => (
                <Box sx={ { width: { xs: logo.width/2, md: logo.width }} }>
                    { logo.link &&
                        <a href={logo.link} target="_blank" data-test-id={'homepage-' + logo.team + '-link'}>
                            <img src={logo.image} width="100%" />
                        </a>

                    }
                    { !logo.link &&
                        <img src={logo.image} width="100%" />
                    }
                </Box>
            ))}
        </Box>
    )
}
